import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeHighlight from 'rehype-highlight';
import styles from './QuestionContent.module.css';

const QuestionContent = ({ text }) => {
    if (!text) return null;
    return (
        <div className={styles.content}>
            <ReactMarkdown
                remarkPlugins={[remarkMath]}
                rehypePlugins={[rehypeKatex, [rehypeHighlight, { detect: true, ignoreMissing: true }]]}
            >
                {text}
            </ReactMarkdown>
        </div>
    );
};

export default QuestionContent;
